import type Vue from 'vue';
import { resolveInjected } from '~/utils/nuxt-instance';

/** The vanilla-cookieconsent instance injected by plugins/cookieConsent.js. */
export function useCookieConsent(): Vue['$CookieConsent'] {
  return resolveInjected('$CookieConsent');
}